import React from 'react';
import { slideWrapper } from '../components/slide';
import { Content } from '../components/content';
import { SlideImage } from '../components/slide-image';
import { PuzzleItem, PuzzleItemsWrapper } from '../components/puzzle-item';
import { Timer } from '../components/timer';
import { useConfirmation } from '../../generic/hooks/use-confirmation';

export const TeslaPuzzle3 = slideWrapper(({ step, data, getImg, ...props }) => {
  const { answers } = step;

  const ConfirmationPopup = useConfirmation(1);
  return (
    <>
      <ConfirmationPopup />
      <Timer data={data} presentation />
      <Content left={-4} bottom={5} xNotCenter yNotCenter>
        <SlideImage width="700px" src={getImg('deska')} show={true} />
      </Content>
      <Content left={15} bottom={7} yNotCenter>
        <SlideImage width="300px" src={getImg('kasa')} show={true} />
      </Content>
      <Content left={15} top={15} yNotCenter>
        <SlideImage width="250px" src={getImg('pistolet')} show={true} />
      </Content>
      <PuzzleItemsWrapper>
        <PuzzleItem getImg={getImg} letter="a" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="b" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="c" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="d" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="e" answers={answers} smallItem />
      </PuzzleItemsWrapper>
    </>
  );
});
